<template lang='pug' src='./custom-home-retainers.pug'></template>

<script>
import { openModal } from '@/methods'

export default {
  props: ['props'],
  mixins: [openModal]
}
</script>



// WEBPACK FOOTER //
// custom-home-retainers.vue?35bf5e60